import React from 'react';
import styled from 'styled-components';
import Image from '../parts/Image';
import Text from '../parts/Text';
import { Link } from 'react-router-dom';
import { GetCafeNotes200ResponseInner } from "../../../api/v1";
import cafectSampleImage from '../../assets/images/cafect_sample.webp';

type CafeNoteListComponentProps = {
  cafeNotes: Array<GetCafeNotes200ResponseInner>
}

const ShopCardsStyle = styled(Link)`
  display: flex;
  border-top: 1px solid #dbdbdb;
  text-decoration: none;
  padding: 30px;

  &:hover {
    background-color: #eeeeee;
    transition: background-color 0.3s ease-in-out
  }

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 10px;
  }
`;

const ColumnLeft = styled.div`
  margin-right: 20px;

  @media (max-width: 768px) {
    margin-right: 0;
    img {
      width: 100%;
    }
  }
`;

const ColumnRight = styled.div`
  width: 100%;
`;

const Note = styled.div`

`;

const CafeNoteList: React.FC<CafeNoteListComponentProps> = ({ cafeNotes }) => {

  const excerptNote = (note: string) => {
    const noteToTextNote = note.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'');
    return noteToTextNote.length > 50 ? noteToTextNote.substring(0, 50) + '...' : noteToTextNote + '...';
  };

  return (
    <>
      { cafeNotes.map((cafeNotes, index) => {
        return (
          <ShopCardsStyle key={index} to={`/user/cafe-notes/${cafeNotes.id}`}>
            <ColumnLeft>
              <Image src={cafeNotes.images[0] ? cafeNotes.images[0]?.url : cafectSampleImage} width='300px' height='170px' />
            </ColumnLeft>
            <ColumnRight>
              <Text size='24px' weight='bold' mb='5px'>{ cafeNotes.title || 'タイトル未設定' }</Text>
              <Note>
                <Text>店舗名：{ cafeNotes.shop?.name }</Text>
                <Text>感想：{ excerptNote(cafeNotes.body) }</Text>
                <Text>日付：{ cafeNotes.visitingDate }</Text>
                <Text>場所：{ cafeNotes.shop?.address }</Text>
              </Note>
            </ColumnRight>
          </ShopCardsStyle>
        );
      })}
    </>
  );
};

export default CafeNoteList;
